import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import { useDispatch, useSelector } from "react-redux";
import { getAgents } from "actions/agents";

export const Agents = ({ navigation }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const agents = useSelector((state) => state.agents.agents);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const [retrievedAgents, setRetrievedAgents] = useState(false);

  useEffect(() => {
    if (agents.length === 0 && !retrievedAgents) {
      setRetrievedAgents(true);
      dispatch(getAgents());
    } else {
      const keys = [
        "id",
        "name",
        "description",
        "user",
        "public_id",
        "actions",
      ];
      setHead(keys);
      setBody(
        agents.map((agent) => {
          const values = [
            agent.id,
            <div style={{ width: "160px", fontWeight: "bold" }}>
              {agent.name}
            </div>,
            <div style={{ width: "500px", textWrap: "balance" }}>
              <div>
                {agent.description ? (
                  <>
                    <span style={{ fontWeight: "bold" }}>Description: </span>
                    {agent.description}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div>
                {agent.identity ? (
                  <>
                    <span style={{ fontWeight: "bold" }}>Identity: </span>
                    {agent.identity}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>,
            agent.user,
            agent.public_id,
            <></>,
          ];
          return values;
        })
      );
    }
  }, [agents, retrievedAgents, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editAgent = (row) => {
    const agent = {};
    head.forEach((key, index) => {
      agent[key] = row[index];
    });
    //NiceModal.show('add-agent', {agent: agent});
    navigate(`/admin/agent/${agent.public_id}`);
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <CardFullTable
                title="Agents"
                titlebutton={
                  <i
                    onClick={() => navigate("/admin/agent/")}
                    className="fa fa-plus text-sm cursor-pointer"
                  />
                }
                head={head}
                body={body}
                color="white"
                onRowClick={(row) => editAgent(row)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Agents;
